
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"course"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"object_course"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"texts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalSpacing"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalTexts"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalTextsWYSIWYG"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalImages"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalH2"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalH3"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalH4"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalH5"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalIntro"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalWYSIWYGText"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalObjectRelation"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"wysiwygImageRow"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"scorecardTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scorecard"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalFiles"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardLinks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalLinks"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"requirementsTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalFiles"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"announcementsTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalFiles"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"rulesTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rules"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalFiles"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"competitionRulesTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"competitionRules"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalFiles"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"imageCourse"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalImages"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingLinks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalLinks"},"directives":[]}]}}]}}],"loc":{"start":0,"end":869}};
    doc.loc.source = {"body":"fragment course on object_course {\n    id\n    text\n    texts {\n        ...generalSpacing\n        ...generalTexts\n        ...generalTextsWYSIWYG\n        ...generalImages\n        ...generalH2\n        ...generalH3\n        ...generalH4\n        ...generalH5\n        ...generalIntro\n        ...generalWYSIWYGText\n        ...generalObjectRelation\n        ...wysiwygImageRow\n    }\n    scorecardTitle\n    scorecard {\n        ...generalFiles\n    }\n    scoreCardLinks {\n        ...generalLinks\n    }\n    requirementsTitle\n    requirements {\n        ...generalFiles\n    }\n    announcementsTitle\n    announcements {\n        ...generalFiles\n    }\n    rulesTitle\n    rules {\n        ...generalFiles\n    }\n    competitionRulesTitle\n    competitionRules {\n        ...generalFiles\n    }\n    imageCourse {\n        ...generalImages\n    }\n    bookingLinks {\n        ...generalLinks\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["course"] = oneQuery(doc, "course");
        
